import { CellContext, createColumnHelper } from '@tanstack/react-table';

import { formatDate } from '@/portainer/filters/filters';
import helm from '@/assets/ico/vendor/helm.svg?c';

import { Link } from '@@/Link';
import { Icon } from '@@/Icon';

import { CustomResourceDefinition } from '../types';

import { actions } from './columns/actions';

const columnHelper = createColumnHelper<CustomResourceDefinition>();

export const columns = [
  columnHelper.accessor('name', {
    id: 'name',
    header: 'Name',
    cell: ({ getValue }: CellContext<CustomResourceDefinition, string>) => {
      const name = getValue();
      return (
        <Link
          to="kubernetes.moreResources.customResourceDefinition"
          params={{ name }}
          data-cy={`crd-name-link-${name}`}
        >
          {name}
        </Link>
      );
    },
  }),
  columnHelper.accessor((row) => !!(row.releaseName && row.releaseNamespace), {
    id: 'managedBy',
    header: 'Managed by',
    cell: ({ row }: CellContext<CustomResourceDefinition, boolean>) => {
      const { releaseName, releaseNamespace, releaseVersion } = row.original;
      if (!releaseName || !releaseNamespace) {
        return '-';
      }
      return (
        <div className="flex flex-col">
          <Link
            to="kubernetes.helm"
            params={{ name: releaseName, namespace: releaseNamespace }}
            className="flex items-center gap-1"
            data-cy={`crd-helm-link-${releaseName}`}
          >
            <Icon icon={helm} />
            {releaseNamespace}/{releaseName}
          </Link>
          {releaseVersion && (
            <span className="text-muted small">{releaseVersion}</span>
          )}
        </div>
      );
    },
  }),
  columnHelper.accessor('group', {
    id: 'group',
    header: 'Group',
    cell: ({ getValue }: CellContext<CustomResourceDefinition, string>) =>
      getValue(),
  }),
  columnHelper.accessor('scope', {
    id: 'scope',
    header: 'Scope',
    cell: ({ getValue }: CellContext<CustomResourceDefinition, string>) =>
      getValue(),
  }),
  columnHelper.accessor('creationDate', {
    id: 'created',
    header: 'Created',
    cell: ({ getValue }: CellContext<CustomResourceDefinition, string>) =>
      formatDate(getValue()),
  }),
  actions,
];
